import { userBotsSagas } from '@store/user-bots/sagas';
import { all, call } from 'redux-saga/effects';

import { alertsSagas } from './alerts/sagas';
import { bannersSagas } from './banners/sagas';
import { broadcastMessagesSagas } from './broadcast-messages/sagas';
import { chatsSagas } from './chats/sagas';
import { fileSagas } from './files/sagas';
import { initSaga } from './initiation/sagas';
import { languagesSagas } from './languages/sagas';
import { meetingSagas } from './meetings/sagas';
import { notificationsSagas } from './notifications/sagas';
import { openAiSagas } from './openAI/sagas';
import { profileSagas } from './profile/sagas';
import { purchaseSagas } from './purchase/sagas';
import { topicSagas } from './topics/sagas';
import { usersSagas } from './users/sagas';

function* rootSaga() {
  yield all([
    call(initSaga),
    call(profileSagas),
    call(meetingSagas),
    call(topicSagas),
    call(languagesSagas),
    call(alertsSagas),
    call(chatsSagas),
    call(usersSagas),
    call(notificationsSagas),
    call(openAiSagas),
    call(bannersSagas),
    call(purchaseSagas),
    call(userBotsSagas),
    call(fileSagas),
    call(broadcastMessagesSagas),
  ]);
}

export default rootSaga;
